module.exports = __webpack_public_path__ + "img/LF007-07.ca5b8a38.jpg";